import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { Select } from 'components';
import { Button } from 'components-antd';
import { NavButtonLeft, NavButtonRight } from '../NavButtons';
import { Close } from 'components/Icons';
import { CalendarView } from 'pages/Calendar/constants';
import { MonthYearPopover, Filters } from 'pages/Calendar/components';
import { TeamFilter } from 'pages/ClarityRevamped/Components/Filters';

import styles from './styles.module.scss';

export const Header = ({
  currentDate,
  setCurrentDate,
  handlePrev,
  handleNext,
  handleToday,
  view,
  setView,
  isShowTeamFilter,
  isOverdueMilestones,
}) => {
  const history = useHistory();
  const showNavigationButton = useMemo(
    () => view !== CalendarView.WEEK && !isOverdueMilestones,
    [view, isOverdueMilestones],
  );

  return (
    <div className={styles.calendarHeader}>
      {showNavigationButton && <NavButtonLeft handlePrev={handlePrev} />}
      <MonthYearPopover
        currentDate={currentDate}
        view={view}
        setCurrentDate={setCurrentDate}
        isOverdueMilestones={isOverdueMilestones}
      />
      {showNavigationButton && <NavButtonRight handleNext={handleNext} />}
      <div className={styles.rightSection}>
        {!isOverdueMilestones && (
          <>
            <Button variant="hollow-bordered" className={styles.todayBtn} onClick={handleToday}>
              Today
            </Button>
            <Select
              options={[
                { name: 'Month', value: CalendarView.MONTH },
                { name: 'Week', value: CalendarView.WEEK },
                { name: 'Day', value: CalendarView.DAY },
              ]}
              value={view}
              onSelect={(e) => setView(e.target.value.value)}
              variant={Select.LIGHT_ROUND}
              selectWrapperClassname={styles.viewSwitcher}
            />
          </>
        )}
        {isShowTeamFilter && <TeamFilter isHideTitle className={styles.teamFilter} />}
        {!isOverdueMilestones && <Filters />}
        {isOverdueMilestones && (
          <Button
            variant="hollow-bordered"
            className={styles.closeBtn}
            onClick={() => history.goBack()}
          >
            <Close className={styles.closeIcon} />
          </Button>
        )}
      </div>
    </div>
  );
};
